import { Form, Input, Button } from 'antd';
import React from 'react';
import { LoginStyle } from './style';
import { Store } from 'antd/lib/form/interface';
import { apiLogin } from 'api';
import { useDispatch } from 'react-redux';
import { setMenuListState } from 'store/slice/menuList';
import { useNavigate } from 'react-router-dom';
import { setBreadcrumbState } from 'store/slice/title';
import { setUserInfoState } from 'store/slice/userInfo';
import logo from 'assets/logo.png';
import { setButtonListState } from 'store/slice/buttonList';
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 }
};
const tailLayout = {
  wrapperCol: { offset: 6, span: 15 },
};
const LoginForm = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [form] = Form.useForm();
  const onFinish = (values: Store) => {
    console.log('onFinish', values);
    form.validateFields()
      .then(values => {
        apiLogin({
          ...values
        })
          .then(res => {
            console.log('res', res);
            dispatch(setMenuListState({ menuList: res.menuList }));
            dispatch(setUserInfoState({ ...res.userInfo }));
            dispatch(setButtonListState({ buttonList: res.buttonList }));
            localStorage.setItem('token', res.userInfo.token);
            navigate(res.menuList[0].menuVOS[0].menuVOS[0].url);
            dispatch(setBreadcrumbState({ title: res.menuList[0].name, menuName: res.menuList[0].menuVOS[0].name + '/' +  res.menuList[0].menuVOS[0].menuVOS[0].name}))
          })
          .catch(err => {
            console.log(err)
          })
      })
      .catch(info => {
        console.log('Validate Failed:', info)
      })
  }
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
 
  return (
    <LoginStyle>
      <div className="login">
        <p><img src={logo}></img></p>
        <Form
          {...layout}
          name="basic"
          form={form}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}>
          <Form.Item
            label="手机号："
            name="userAccount"
            rules={[{ required: true, message: '请输入手机号' }]}>
            <Input />
          </Form.Item>

          <Form.Item
            label="密码："
            name="userPassword"
            rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password />
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              登录
            </Button>
          </Form.Item>
        </Form>
      </div>
    </LoginStyle>
  )
}

export default LoginForm
